"use client";
import { use, useEffect, useState } from "react";

export const GoogleButton = ({ csrf }: any) => {
  const [csrfToken, setCsrfToken] = useState(csrf);
  const [callbackUrl, setCallbackUrl] = useState("https://localhost:3001");

  useEffect(() => {
    const logout = async () => {
      try {

        const response = await fetch(
          `${process.env.NEXT_PUBLIC_WALDEM_API}/api/users/auth/signout`,
          {
            method: "POST",
            credentials: "include",
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
            body: new URLSearchParams({ 
              csrfToken
            }).toString(),
            redirect: 'manual'
          }
        );

        console.log("Logout realizado com sucesso");
        
      } catch (error) {

        
        document.cookie = "authjs.session-token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
        document.cookie = "authjs.csrf-token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
        document.cookie = "authjs.pkce.code_verifier=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
        
  
        if (process.env.NODE_ENV === 'production') {
          document.cookie = "authjs.session-token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=.waldem.com.br";
          document.cookie = "authjs.csrf-token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=.waldem.com.br";
          document.cookie = "authjs.pkce.code_verifier=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=.waldem.com.br";
        }
        
        console.log("Cookies de sessão limpos");
      }
    };

    logout();
  }, [csrfToken]);

  console.log(csrf);

  return (
    <form
      action={`${process.env.NEXT_PUBLIC_WALDEM_API}/api/users/auth/signin/google`}
      method="POST"
      className="flex gap-4"
    >
      {/* Hidden CSRF Token Field */}
      <input type="hidden" name="csrfToken" value={csrf} />
      <button
        type="submit"
        className="
              flex items-center justify-center
              w-30
              px-4 py-2
              text-sm
              bg-gradient-to-b from-slate-800 to-slate-900
              hover:from-slate-700 hover:to-slate-800
              text-white font-semibold
              rounded-lg
              shadow-md
              transition duration-200
              focus:outline-none focus:ring-2 focus:ring-blue-400
           
            "
      >
        {/* Google Icon */}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="1.5em"
          height="1.5em"
          viewBox="0 0 24 24"
          className=" mr-1"
        >
          <path
            fill="currentColor"
            d="M3.064 7.51A10 10 0 0 1 12 2c2.695 0 4.959.991 6.69 2.605l-2.867 2.868C14.786 6.482 13.468 5.977 12 5.977c-2.605 0-4.81 1.76-5.595 4.123c-.2.6-.314 1.24-.314 1.9s.114 1.3.314 1.9c.786 2.364 2.99 4.123 5.595 4.123c1.345 0 2.49-.355 3.386-.955a4.6 4.6 0 0 0 1.996-3.018H12v-3.868h9.418c.118.654.182 1.336.182 2.045c0 3.046-1.09 5.61-2.982 7.35C16.964 21.105 14.7 22 12 22A9.996 9.996 0 0 1 2 12c0-1.614.386-3.14 1.064-4.49"
          ></path>
        </svg>
        Google
      </button>
    </form>
  );
};